import { useRouter, type RouteRecordRaw } from 'vue-router';
import { NotFoundView } from '~/views/errors';

export const fallbackRoutes: RouteRecordRaw[] = [
    {
        name: '404',
        path: '/:catchAll(.*)*',
        component: NotFoundView,
        beforeEnter: (to, from, next) => {
            if (__DEBUG__) {
                console.error(`No route found for path: ${to.fullPath}`);
                console.log(JSON.parse(JSON.stringify(useRouter()?.getRoutes() ?? null)));
            }
            next();
        },
    },
];
